import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MailCheck } from "lucide-react";
import { EmptyState, PageLoading, PageHeader, fmtDate, fmtDateTime } from "@/components/shared";
import api from "@/lib/api";

export default function AdminReminders() {
  const { t } = useTranslation();
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/reminders").then((r) => setRows(r.data.reminders)); }, []);
  const docLabel = (k) => (k === "doc_passport" ? t("rem.passport") : t("rem.permit"));
  const bucketLabel = (b) => ({ expired: t("rem.expired"), "90": t("rem.d90"), "30": t("rem.d30"), "7": t("rem.d7") }[b] || b);
  if (rows === null) return <PageLoading />;
  return (
    <div data-testid="admin-reminders">
      <PageHeader title={t("rem.title")} subtitle={t("rem.subtitle")} />
      {rows.length === 0 ? <EmptyState icon={MailCheck} title={t("rem.empty")} subtitle={t("rem.emptySub")} /> : (
        <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white">
          <table className="w-full text-sm" data-testid="admin-reminders-table">
            <thead className="border-b border-slate-200 bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-400">
              <tr><th className="px-4 py-3">{t("rem.colEmployee")}</th><th className="px-4 py-3">{t("rem.colCompany")}</th><th className="px-4 py-3">{t("rem.colDocument")}</th><th className="px-4 py-3">{t("rem.colWhen")}</th><th className="px-4 py-3">{t("rem.colDue")}</th><th className="px-4 py-3">{t("rem.colRecipients")}</th><th className="px-4 py-3">{t("rem.colLang")}</th><th className="px-4 py-3">{t("rem.colSent")}</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.key} className="border-b border-slate-50 hover:bg-slate-50">
                  <td className="px-4 py-3 font-semibold text-navy">{r.employee_name}</td>
                  <td className="px-4 py-3 text-slate-600">{r.company}</td>
                  <td className="px-4 py-3 text-slate-600">{docLabel(r.doc_label)}</td>
                  <td className="px-4 py-3"><span className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${r.bucket === "expired" ? "border-red-200 bg-red-50 text-red-600" : r.bucket === "7" ? "border-amber-200 bg-amber-50 text-amber-600" : "border-slate-200 bg-slate-50 text-slate-500"}`}>{bucketLabel(r.bucket)}</span></td>
                  <td className="px-4 py-3 text-slate-600">{fmtDate(r.due_date)}</td>
                  <td className="px-4 py-3 text-xs text-slate-500">{(r.recipients || []).join(", ") || "—"}</td>
                  <td className="px-4 py-3 text-slate-600 uppercase">{r.lang}</td>
                  <td className="px-4 py-3 text-slate-500">{fmtDateTime(r.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
